import { newE2EPage } from "@stencil/core/testing";

describe("pagination", () => {
    it("should log an error if totalPages prop is not set", async () => {
        const error = jest.spyOn(global.console, "error");
        const page = await newE2EPage({
            html: `<ux-pagination></ux-pagination>`
        });
        const el = await page.find("ux-pagination");
        expect(el).toHaveClass("hydrated");
        expect(error).toHaveBeenCalled();
        error.mockReset();
        error.mockRestore();
    });

    it("should display all pages by default if totalPages <= 7", async () => {
        const page = await newE2EPage({
            html: `<ux-pagination total-pages="5"></ux-pagination>`
        });
        const el = await page.find("ux-pagination");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should display the first 5 pages if totalPages > 7", async () => {
        const page = await newE2EPage({
            html: `<ux-pagination total-pages="50"></ux-pagination>`
        });
        const el = await page.find("ux-pagination");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should show the mobile input when there's not enough space", async () => {
        const page = await newE2EPage({
            html: `<div style="width: 300px"><ux-pagination total-pages="50"></ux-pagination><div>`
        });
        const el = await page.find("ux-pagination");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should focus the input field when clicking on the ellipsis and change the page after 750ms", async () => {
        const page = await newE2EPage({
            html: `<ux-pagination total-pages="50"></ux-pagination>`
        });
        const el = await page.find("ux-pagination");
        await page.waitForChanges();

        const uxShow = await page.spyOnEvent("uxShow");

        const ellipsis = await page.find(".ux-pagination__ellipsis");
        await ellipsis.click();
        await page.waitForChanges();
        expect(uxShow).toHaveReceivedEvent();

        const popover = await page.find("ux-popover");
        expect(popover).toHaveAttribute("opened");

        await page.keyboard.press("Backspace");
        await page.keyboard.press("2");
        await page.keyboard.press("0");

        await page.waitForTimeout(750);
        await page.waitForChanges();

        const currentPage = await el.getProperty("page");
        expect(currentPage).toEqual(20);
    });
});
